var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.DataSrcMngrDataRequest = new Class({
    Extends: OCS.Viewer.Classes.DataMngrDataRequest,
    class_name: "DataSrcMngrDataRequest",
    dsm_manager: null,
    options: {
        source_type: '',
        metadata: {
            req_cat_type: 'DataSrcMngrDataRequest'
        }
    },
    on_make_request_active: function () {
        var dataset = OCS.Functions.get_dataset_from_node(this.get_dataset());
        var datatype = dataset.get_datatype();
        if (this.init_data || datatype === "shapefile" || datatype === "userdata") {
            var source = this.create_source(this.init_data);
            if (this.init_data) {
                source.process_data();
            }
            source.create();
            this.fireEvent('has_data', [this, source]);
            this.success();
        } else {
            this.parent();
        }
    },
    on_data_ready: function (data) {
        if (data && !OCS.Viewer.Functions.get_utilities().is_undefined(OCS.Viewer.Classes[this.options.metadata.source_type + "Source"])) {
            var timestamp_epoch = data.get_timestamp_epoch();
            var source = this.create_source(data, timestamp_epoch);
            var args = [this, source];
            if (timestamp_epoch) {
                args.push(timestamp_epoch);
                this.set_data(source);
            }
            this.fireEvent('has_data', args);
            this.success();
        }
    },
    is_data_valid: function (data) {
        var data_container = data.data();
        if (Object.keys(data_container).length && this.parent(data)) {
            return true;
        }
        return false;

    },
    create_source: function (data, timestamp_epoch) {
        var source = new OCS.Viewer.Classes[this.options.metadata.source_type + "Source"](this.options);
        if (timestamp_epoch) {
            source.set_timestamp_epoch(timestamp_epoch);
        }
        source.set_data(data);
        return source;
    }
});